/**
 * Auto-hide the mega-nav when scrolling down, reveal when scrolling up.
 *
 * - Toggles `data-nav-hidden` and `data-nav-scrolled` on `[data-menu-wrap]`.
 * - Reads `data-menu-open` (set by nav.js) so the bar can't hide
 *   while the mobile menu / desktop dropdown is open.
 * - rAF-throttled, transform-based (composited, no reflow).
 * - Respects prefers-reduced-motion via the matching CSS rule.
 */

const THRESHOLD = 8;
const TOP_GUARD = 80;

function init() {
  const navs = document.querySelectorAll("[data-menu-wrap]");
  if (!navs.length) return;

  let lastY = window.scrollY;
  let ticking = false;

  function update() {
    const y = window.scrollY;
    const delta = y - lastY;

    navs.forEach((nav) => {
      nav.setAttribute("data-nav-scrolled", y > 4 ? "true" : "false");

      if (nav.getAttribute("data-menu-open") === "true" || y < TOP_GUARD) {
        nav.setAttribute("data-nav-hidden", "false");
      } else if (delta > THRESHOLD) {
        nav.setAttribute("data-nav-hidden", "true");
      } else if (delta < -THRESHOLD) {
        nav.setAttribute("data-nav-hidden", "false");
      }
    });

    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    "scroll",
    () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true },
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
